import type { Enum } from '@/types/Enum'
import type {
  PursuitTerminalStatus,
  PursuitType,
} from '@/types/pursuit/Pursuit'

// ─── Terminal Status Constants ───────────────────────────────────────────────

export const TERMINAL_STATUS_LABELS: Record<PursuitTerminalStatus, string> = {
  won: 'Won',
  lost: 'Lost',
  no_bid: 'No Bid',
}

export const TERMINAL_STATUS_BADGE_STYLES: Record<
  PursuitTerminalStatus,
  string
> = {
  won: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 border border-green-300 dark:border-green-800',
  lost: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 border border-red-300 dark:border-red-800',
  no_bid:
    'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 border border-yellow-300 dark:border-yellow-800',
}

export const TERMINAL_STATUS_DOT_STYLES: Record<PursuitTerminalStatus, string> =
  {
    won: 'bg-green-600 dark:bg-green-500',
    lost: 'bg-red-600 dark:bg-red-500',
    no_bid: 'bg-yellow-600 dark:bg-yellow-500',
  }

export const TERMINAL_STATUSES: {
  key: PursuitTerminalStatus
  label: string
}[] = [
  { key: 'won', label: 'Won' },
  { key: 'lost', label: 'Lost' },
  { key: 'no_bid', label: 'No Bid' },
]

export const STATUS_NAMES: Array<Enum> = [
  {
    id: 'not_started',
    title: 'Not Started',
  },
  {
    id: 'in_progress',
    title: 'In Progress',
  },
  {
    id: 'in_review',
    title: 'In Review',
  },
  {
    id: 'awaiting_award',
    title: 'Awaiting Award',
  },
  {
    id: 'completed',
    title: 'Completed',
  },
]

export const DEFAULT_PWIN_FILTER: number[] = [0, 100]
export const DEFAULT_ESTIMATED_VALUE_FILTER: number[] = [0, 1e12]

export const PURSUIT_TYPES: PursuitType[] = [
  'federal_contract_pursuit',
  'federal_grant_pursuit',
  'sbir_pursuit',
  'sled_contract_pursuit',
]

export type Stage =
  | 'Assessment'
  | 'Pursuit'
  | 'Pre-Proposal'
  | 'Proposal'
  | 'Submittal'
  | 'Won/Lost'

// TODO: remove these when we add back pipeline stages (7/29/2024)
export const STAGES: Stage[] = [
  'Assessment',
  'Pursuit',
  'Pre-Proposal',
  'Proposal',
  'Submittal',
  'Won/Lost',
]

export const STAGE_ENUMS: Enum[] = STAGES.map((stage) => ({
  id: stage,
  title: stage,
  display: stage.toLowerCase(),
}))

export const STAGE_TO_PWIN: Record<Stage, number> = {
  Assessment: 0,
  Pursuit: 10,
  'Pre-Proposal': 20,
  Proposal: 30,
  Submittal: 40,
  'Won/Lost': 50,
}
